import React from 'react';
import classNames from '../helpers/classNames.js';
const Page = ({
  children,
  header,
  subHeader = null,
  footer = null,
  toc
}) => /*#__PURE__*/React.createElement("div", {
  className: "ebds-page"
}, header, /*#__PURE__*/React.createElement("div", {
  className: "ebds-page__container"
}, /*#__PURE__*/React.createElement("div", {
  className: "ebds-page__content-wrapper"
}, /*#__PURE__*/React.createElement("main", {
  className: classNames('ebds-main', {
    '--has-sub-header': subHeader
  })
}, subHeader, children, toc))), footer);
export default Page;